<script>
	import { fade } from "svelte/transition";
	export let name;
	export let timeout;
	let transitioning = false;
	export let display;
	$: change(name);

	function change() {
		transitioning = true;
		setTimeout(() => {
			transitioning = false;
		}, timeout);
	}
</script>

<div class:green={transitioning}>
	{#if !transitioning}
		<div in:fade={{ duration: 200 }}>
			{@html display}
		</div>
	{/if}
</div>

<style>
	.green {
		color: #009e9d;
	}
</style>
